
import type { TargetTaxonomyKey } from "./TargetTaxonomy.ts";

// Generated from io.spcfy.orders.persistence.ProcessingType

export type ProcessingTypeKey =
  "METABARCODING" |
  "EDNA";


export interface ProcessingTypeDTO {
  key: ProcessingTypeKey;
  label: string;
  allowedTargetTaxonomies?: TargetTaxonomyKey[];    
}


export const ProcessingTypes: Record<ProcessingTypeKey, ProcessingTypeDTO> = {
  METABARCODING: { key: "METABARCODING", label: "Metabarcoding" },
  EDNA: { key: "EDNA", label: "eDNA", allowedTargetTaxonomies: ["16S_VERTEBRATES", "12S_FISH"] }
};
